import { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
// @ts-ignore
import QrReader from "react-qr-reader";
import { Box, Button, useTheme } from "@mui/material";
import Layout from "Components/Layout/Layout";
import VehiclesNavigation from "Navigation/VehiclesNavigation";
import useCollectionSession from "./useCollectionSession";

const CollectionSessionScanPage = () => {
	const { id } = useParams<{ id: string }>();
	const history = useHistory();
	const theme = useTheme();
	const { addVehicle } = useCollectionSession(id);

	const [error, setError] = useState<Error>();
	const [scanning, setScanning] = useState(false);

	const handleScan = async (data: string) => {
		if (!data || scanning) {
			return;
		}

		if (data.startsWith("pickup://")) {
			setScanning(true);
			try {
				const added = await addVehicle({ pickupToken: data.substring(9) });
				if (added) {
					history.push(`/vehicles/collection-sessions/${id}`);
				}
			} finally {
				setScanning(false);
			}
			return;
		}

		const match = data.match(/^fin:\/\/(?<vin>[0-9A-HJ-NPR-Z]{17})$/i);
		if (!match || !match.groups || !match.groups["vin"]) {
			setError(new Error(`Ungültiges Format des QR-Codes. Folgender Text wurde extrahiert: ${data}`));
			return;
		}

		setScanning(true);
		try {
			const added = await addVehicle({ vin: match.groups["vin"] });
			if (added) {
				history.push(`/vehicles/collection-sessions/${id}`);
			}
		} finally {
			setScanning(false);
		}
	};

	return (
		<Layout title="Fahrzeug zur Sammelsitzung hinzufügen" navigation={<VehiclesNavigation />}>
			<Box sx={{
				display: "flex",
				flexDirection: "column",
				flexGrow: 1,
				lineHeight: "1.4rem"
			}}>
				{!!error && (
					<Box>
						<Button
							fullWidth
							variant="contained"
							size="medium"
							onClick={() => setError(undefined)}
						>Erneut versuchen</Button>
						<Box mt={3} sx={{ color: theme.palette.error.main }}>
							<Box sx={{ fontWeight: 600 }}>Fehler</Box>
							<div>{error.message}</div>
						</Box>
					</Box>
				)}
				{!error && (
					<Box sx={{
						display: "flex",
						flexGrow: 1,
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center"
					}}>
						<QrReader
							delay={100}
							onError={(e: Error) => setError(e)}
							onScan={handleScan}
							style={{ width: "100%", maxWidth: 500 }}
						/>
					</Box>
				)}
			</Box>
		</Layout>
	);
};

export default CollectionSessionScanPage;
